var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('footer',{staticClass:"mt-3 mb-1 text-blue"},[_c('div',{staticClass:"row text-white gradient rounded ml-1 mr-1"},[_c('div',{staticClass:"col text-center mb-0",staticStyle:{"font-size":"12px"}},[_vm._v(" 2024 Copyright Baiturrahman Mobile ")])])])])
}]

export { render, staticRenderFns }